module.exports = __webpack_public_path__ + "static/media/pro3.b9a0a759.jpg";